import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import fixedClasses from './goodie-giveaway-tabs-select-fixed.scss';
import responsiveClasses from './goodie-giveaway-tabs-select.scss';
export const GoodieGiveawayTabsSelect = ({
  isFixed = false,
  tabs,
  currentTab,
  giveawayColor
}) => {
  const dropdown = useRef(null);
  const menu = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const classes = isFixed ? fixedClasses : responsiveClasses;
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleClickOutside = event => {
    if (!(dropdown !== null && dropdown !== void 0 && dropdown.current) || !(menu !== null && menu !== void 0 && menu.current)) {
      return;
    }
    const notAtDropdown = !dropdown.current.contains(event.target);
    const notAtMenu = !menu.current.contains(event.target);
    if (dropdown && menu && notAtDropdown && notAtMenu) {
      toggleOpen();
    }
  };
  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
  const renderValue = () => {
    const FilledArrow = isOpen ? ArrowDropUp : ArrowDropDown;
    return /*#__PURE__*/React.createElement("div", {
      ref: menu,
      onClick: toggleOpen,
      className: classes.mobileWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.renderValue, {
        [classes.withBorder]: isOpen
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.mobileSelectedItem
    }, currentTab.text), /*#__PURE__*/React.createElement(FilledArrow, {
      className: classes.arrow
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderValue(), isOpen ? /*#__PURE__*/React.createElement("div", {
    ref: dropdown,
    className: classnames(classes.paper, classes.mobileList)
  }, tabs.map(({
    route,
    text,
    categoryId
  }) => /*#__PURE__*/React.createElement(Link, {
    className: classnames(classes.mobileMenuItem, {
      [classes.selectedMenuItem]: route === currentTab.route
    }),
    style: route === currentTab.route ? {
      color: giveawayColor
    } : {},
    key: route,
    "data-categoryId": categoryId,
    to: route,
    onClick: toggleOpen
  }, text))) : null);
};